import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getIcon } from '../../util/icons';

class MessageModal extends Component{

  render(){

    const { message, messageHtml, iconKey, buttonText, buttonClass, forceOpen } = this.props;

    if(!this.props.visible){
      return null;
    }

    return (
      <div className="modal">
        <div className="modal-container">
          {!forceOpen &&
            <div className="close-icon" onClick={this.props.hide}>X</div>
          }
          <div className="modal-content">
            <div className="message-icon">{getIcon(iconKey || 'info')}</div>
            {message &&
              <div className="message">
                <p>{message}</p>
              </div>
            }
            {messageHtml &&
              <div className="message" dangerouslySetInnerHTML={{__html: messageHtml}}></div>
            }
          </div>
          {!forceOpen &&
            <div className="modal-actions">
              <button onClick={this.props.hide} className={`button ${buttonClass ? buttonClass : 'primary'}`}>{buttonText ? buttonText : 'OK'}</button>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default MessageModal;



// WEBPACK FOOTER //
// ./src/components/modals/message.js